import React from "react";
import "./ActionButton.scss";
import Loader from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";

const ActionButton = ({
  label,
  icon,
  onClick,
  variant = "outline", // outline | primary
  disabled = false,
  btnTooltopMessage = "",
}) => {
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]',
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
  );
  return (
    <span
      {...(btnTooltopMessage && {
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "top",
        title: btnTooltopMessage,
      })}
    >
      <button
        className={`btn  btn-outline-theme  action-btn ${variant} w-100 `}
        onClick={onClick}
        disabled={disabled}
      >
        {/* {icon && <span className="btn-icon">{icon}</span>} */}
        {icon && <FontAwesomeIcon icon={icon} className="pe-2" />}
        {label}
      </button>
    </span>
  );
};

export default ActionButton;
